import { IVector3 } from './Misc';

export enum PivotSpace {
	Relative = "relative",
	Absolute = "absolute",
}

export interface Pivot {
	displayOffset: IVector3,
	relativeOffset: IVector3,
	geometryOffset: IVector3,
	space: PivotSpace,
}


export enum PivotPropertyNames {
	Offset =  "offset",
	Space = "space",
}
